export default __webpack_public_path__ + "static/headshot-828f5ea4b55ebc18786a5ed7efadf927.png";